
export const baseURL = "https://hd-api-prod.developmentsites.xyz/api/";
export const imageURL = "https://hd-api-prod.developmentsites.xyz/storage";
export const secretKey = "ENTER_YOUR_KEY";
export const projectName = "Hdcutz";
